import { useContext, useEffect, useState } from 'react';
import { ScreenRenderForm } from '@taxdown/kami-sama/dist/kamiSama/definition';
import {
  ScreenClassify,
  ScreenSummary,
  ScreenYayoyaki,
  YayoyakiValue,
  ScreenAdd,
} from '@taxdown/kami-sama/dist/kamiSama';
import { history } from 'Store';
import { getChildIndex } from 'Store/modules/router/selectors';
import KamiContext, { VALIDATION_END_SCREEN, VALIDATION_EXIT_ROUTE } from 'Context/KamiContext';

export interface UseScreenType {
  screen: ScreenYayoyaki | ScreenSummary | ScreenAdd | ScreenClassify;
  renderForm: ScreenRenderForm;
  onNextScreen: () => void;
  onPrevScreen: () => void;
  onReloadYayos: () => void;
  onReloadForm: () => void;
  yayoyakis: YayoyakiValue[];
}

export interface SummaryScreenType extends Omit<UseScreenType, 'screen'> {
  screen: ScreenSummary;
}
export interface ScreenAddType extends Omit<UseScreenType, 'screen'> {
  screen: ScreenAdd;
}
export interface ScreenClassifyType extends Omit<UseScreenType, 'screen'> {
  screen: ScreenClassify;
}

const useScreen = (screenName: string): UseScreenType => {
  const childIndex = getChildIndex();
  const { kamiSama, forms } = useContext(KamiContext);
  const [screen, setScreen] = useState(
    kamiSama?.getScreen(screenName, childIndex) as ScreenYayoyaki
  );

  const [yayoyakis, setYayoyakis] = useState(screen?.getYayoyakis?.());
  const [renderForm, setRenderForm] = useState(screen?.getRenderForm() || {});

  useEffect(() => {
    const newScreen = kamiSama?.getScreen(screenName, childIndex) as ScreenYayoyaki;
    setScreen(newScreen);
    setYayoyakis(newScreen?.getYayoyakis?.());
    setRenderForm(newScreen?.getRenderForm());
  }, [screenName]);

  const onNextScreen = (): void => {
    if (screenName === VALIDATION_END_SCREEN) {
      history.push(VALIDATION_EXIT_ROUTE);
    } else {
      const nextScreen = kamiSama?.getScreenNext(screen);
      history.push(forms[nextScreen?.getId() ?? ''].path, {
        childIndex: nextScreen?.getNavigationIndex(),
      });
    }
  };

  const onPrevScreen = (): void => {
    const prevScreen = kamiSama?.getScreenPrevious(screen);
    history.push(forms[prevScreen?.getId() ?? ''].path, {
      childIndex: prevScreen?.getNavigationIndex(),
    });
  };

  const onReloadYayos = (): void => {
    setYayoyakis(screen?.getYayoyakis());
  };

  const onReloadForm = (): void => {
    setRenderForm(screen?.getRenderForm());
  };

  return {
    screen,
    yayoyakis,
    renderForm,
    onNextScreen,
    onPrevScreen,
    onReloadYayos,
    onReloadForm,
  };
};

export default useScreen;
